import { createInstantPacket } from 'api/InstantPacket';

import { iaRa } from 'lib/helpers/utility';

import { amountWithoutGratuity } from '../lib/checkoutAmounts';
import {
  PATIENT_FORMS_DOCUMENT_ID,
  PRE_AUTH_DOCUMENT_ID
} from '../components/IncludedDocuments/lib/constants';

const DOCUMENT_FORM_IDS = [
  { documentId: 'insurance-eligibility', formId: 'insurance' },
  { documentId: PRE_AUTH_DOCUMENT_ID, formId: 'pre-auth' }
];

const PACKET_LAST_FORM_IDS = ['payment', 'pre-auth'];

export const documentPacketForms = (
  includedDocuments,
  baseFormId,
  { patientFormIds, paymentFirst = false } = {}
) => {
  const selectedDocuments = iaRa(includedDocuments);
  const documentFormIds = DOCUMENT_FORM_IDS.filter((entry) =>
    selectedDocuments.includes(entry.documentId)
  ).map((entry) => entry.formId);
  const customFormIds = selectedDocuments.includes(PATIENT_FORMS_DOCUMENT_ID)
    ? iaRa(patientFormIds)
    : [];
  const packetFormIds = [...documentFormIds, baseFormId];
  const leadingFormIds = packetFormIds.filter((id) => !PACKET_LAST_FORM_IDS.includes(id));
  const trailingFormIds = packetFormIds.filter((id) => PACKET_LAST_FORM_IDS.includes(id));
  const orderedFormIds = paymentFirst
    ? [...packetFormIds, ...customFormIds]
    : [...leadingFormIds, ...customFormIds, ...trailingFormIds];

  return { formIds: [...new Set(orderedFormIds)] };
};

export const createPatientFormsPacket = (
  navigate,
  { patientId, appointmentId, payment, includedDocuments, patientFormIds }
) =>
  createInstantPacket(navigate, {
    ...documentPacketForms(includedDocuments, 'payment', { patientFormIds, paymentFirst: true }),
    paymentFirst: true,
    patientId,
    ...(appointmentId && { appointmentId }),
    ...(payment && { payment }),
    ...(iaRa(includedDocuments).includes(PRE_AUTH_DOCUMENT_ID) && {
      preAuthOption: 'ongoing-treatments'
    })
  });

export const createCardPreAuthPacket = (navigate, { patientId, appointmentId, cardId }) =>
  createInstantPacket(navigate, {
    formIds: ['pre-auth'],
    patientId,
    cardId,
    preAuthOption: 'ongoing-treatments',
    ...(appointmentId && { appointmentId })
  });

export const withAutoPayCard = (url) => {
  if (!url || !url.includes('/ia/') || url.includes('autopay=')) return url;
  return `${url}${url.includes('?') ? '&' : '?'}autopay=card`;
};

const withParam = (url, key, value) =>
  value ? `${url}${url.includes('?') ? '&' : '?'}${key}=${encodeURIComponent(value)}` : url;

export const buildPacketLink = (token, { autoPayCard = false, invoiceToken = null } = {}) => {
  if (!token) return '';

  const base = /^https?:\/\//i.test(token)
    ? token
    : `${window.location.origin}/ia/${encodeURIComponent(token)}`;

  const withInvoice = withParam(base, 'invoiceToken', invoiceToken);

  return autoPayCard ? withAutoPayCard(withInvoice) : withInvoice;
};

// A packet's payment is made by the patient later, where no tip is collected.
export const packetPaymentPayload = ({ amount, gratuity = 0, surchargeAmount, invoices }) => ({
  amount: amountWithoutGratuity({ amount, gratuity }),
  surchargeAmount: Math.round(Number(surchargeAmount) || 0),
  invoiceIds: iaRa(invoices)
    .map((invoice) => invoice?.id)
    .filter(Boolean)
});
